"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allTermsOfSales = exports.allFreightClassItems = exports.allFreightClasses = exports.allEquipmentTypeItems = exports.getEquipmentTypeIds = exports.allEquipmentTypeIds = exports.allEquipmentTypes = void 0;
const utils_1 = require("@loadsure/utils");
const international_1 = require("../international");
function allEquipmentTypes() {
    return {
        "1": "Other",
        "2": "Dry Van",
        "3": "Flatbed",
        "4": "Reefer",
        "5": "Soft-sided Truck",
        "6": "Conestoga"
    };
}
exports.allEquipmentTypes = allEquipmentTypes;
const allEquipmentTypeIds = () => Object.keys(allEquipmentTypes()).map((s) => Number.parseInt(s, 10));
exports.allEquipmentTypeIds = allEquipmentTypeIds;
const getEquipmentTypeIds = (refrigeratedGoods = false) => exports.allEquipmentTypeIds().filter((n) => (refrigeratedGoods ? n === 4 : n !== 4));
exports.getEquipmentTypeIds = getEquipmentTypeIds;
function allEquipmentTypeItems() {
    return utils_1.objectToItemsNumeric(allEquipmentTypes()).sort((a, b) => {
        if (a.value === 1) {
            return 1;
        }
        if (b.value === 1) {
            return -1;
        }
        return a.value - b.value;
    });
}
exports.allEquipmentTypeItems = allEquipmentTypeItems;
function allFreightClasses() {
    return {
        class50: "Class 50",
        class55: "Class 55",
        class60: "Class 60",
        class65: "Class 65",
        class70: "Class 70",
        class77_5: "Class 77.5",
        class85: "Class 85",
        class92_5: "Class 92.5",
        class100: "Class 100",
        class110: "Class 110",
        class125: "Class 125",
        class150: "Class 150",
        class175: "Class 175",
        class200: "Class 200",
        class250: "Class 250",
        class300: "Class 300",
        class400: "Class 400",
        class500: "Class 500"
    };
}
exports.allFreightClasses = allFreightClasses;
function allFreightClassItems() {
    return utils_1.objectToItems(allFreightClasses());
}
exports.allFreightClassItems = allFreightClassItems;
function allTermsOfSales() {
    return international_1.termsOfSaleTypes;
}
exports.allTermsOfSales = allTermsOfSales;
//# sourceMappingURL=index.js.map